import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Prototype du produit", -1)


  import { useProductStore } from '@/stores/product/prototypeStore';
  import { ref, watch } from 'vue';

    export const selectedPrototype = ref('6a3f537e-fdfd-11ed-a0b1-de1c3c38600f')
    export const getProductPrototype = () => {
      
        const currentProductPrototype = selectedPrototype.value;
        const productStore = useProductStore();
        productStore.setCurrentProductPrototype(currentProductPrototype);
    };

    const __default__ = {
      props: {
      productUuid: String 
      
    },
  }
  

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'PrototypeStep',
  setup(__props) {


  watch(selectedPrototype, () => {
    getProductPrototype();
  });
  


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_FormKit, {
      modelValue: selectedPrototype.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPrototype).value = $event)),
      type: "radio",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (getProductPrototype())),
      options: {
        '6a3f537e-fdfd-11ed-a0b1-de1c3c38600f': 'E-billet',
        '6a3fc06d-fdfd-11ed-a0b1-de1c3c38600f': 'Produit physique',
        '6a3fe435-fdfd-11ed-a0b1-de1c3c38600f': 'Carte cadeau',
        '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f': 'Redirection sur site partenaire / Codes promo',
        '6a401dea-fdfd-11ed-a0b1-de1c3c38600f': 'Carte de membre'
      },
      help: "Selectionner un prototype de produit",
      validation: "required",
      name: "prototype"
    }, null, 8, ["modelValue"])
  ]))
}
}

})